import * as tslib_1 from "tslib";
import { combineLatest, of, ReplaySubject, zip } from 'rxjs';
import { timer } from 'rxjs';
import { OnDestroy } from '@angular/core';
import { filter, flatMap, map, share } from 'rxjs/operators';
import { takeUntilDestroy } from 'take-until-destroy';
import { ACTION_SUFFIX, LABEL_SUFFIX, LOGIN_SUFFIX, LOOKUP_DATA_SUFFIX, MESSAGE_SUFFIX, ORG_STRUCTURE_DESCRIPTION_PREFIX, ORG_STRUCTURE_LOCATION_DESCRIPTION_PREFIX, PROCEDURE_CODE_DESCRIPTION_PREFIX, SPS_CODE_DESCRIPTION_PREFIX, TITLE_SUFFIX } from '../translate.suffix';
import * as i0 from "@angular/core";
import * as i1 from "./translate.proxy";
import * as i2 from "../../intl/services/intl.service";
var TranslateService = /** @class */ (function () {
    function TranslateService(translateProxy, intlServicePP) {
        var _this = this;
        this.translateProxy = translateProxy;
        this.intlServicePP = intlServicePP;
        this.preLoginDictionary = {};
        this.dictionary = {};
        this.preLoginDicInited = new ReplaySubject(1);
        this.translateProxy.getPreLoginTranslations().pipe(takeUntilDestroy(this)).subscribe(function (res) {
            _this.preLoginDictionary = res;
            _this.preLoginDicInited.next();
        });
        this.intlServicePP.getUsedLanguageObservable().pipe(takeUntilDestroy(this)).subscribe(function (lang) {
            if (lang && !_this.dictionary[lang.languageKey.toString()]) {
                _this.getTranslationsFromServer(lang.languageKey.toString()).pipe(takeUntilDestroy(_this)).subscribe(function (dictionary) {
                    _this.dictionary[lang.languageKey.toString()] = _this.dictionary[lang.languageKey.toString()] ?
                        Object.assign(_this.dictionary[lang.languageKey.toString()], dictionary) : dictionary;
                    _this.intlServicePP.setLanguage(lang, false, lang.manualSelect);
                });
            }
        });
    }
    TranslateService.prototype.ngOnDestroy = function () { };
    TranslateService.prototype.transformLogin = function (key) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return combineLatest(this.preLoginDicInited.asObservable(), this.intlServicePP.getUsedLanguageObservable().pipe(filter(function (currLanguageSelection) { return currLanguageSelection.manualSelect; })))
            .pipe(map(function (preLoginAndlang) {
            var lang = preLoginAndlang[1];
            var currDict = _this.preLoginDictionary[lang.languageKey.toString()];
            return currDict ? (currDict[key] ? _this.stringFormatter(currDict[key], args) : '[' + key + ']') : '';
        }));
    };
    TranslateService.prototype.transform = function (key) {
        var _this = this;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (key.indexOf(LOGIN_SUFFIX) > -1) {
            return this.transformLogin(key, args);
        }
        else {
            return combineLatest(this.preLoginDicInited.asObservable(), this.intlServicePP.getUsedLanguageObservable())
                .pipe(map(function (preLoginAndlang) {
                var lang = preLoginAndlang[1];
                var currDict = _this.dictionary[lang.languageKey.toString()];
                return currDict ? (currDict[key] ? _this.stringFormatter(currDict[key], args) : '[' + key + ']') : '';
            }));
        }
    };
    TranslateService.prototype.transformLookup = function (key) {
        var _this = this;
        return this.intlServicePP.getUsedLanguageObservable().pipe(flatMap(function (lang) {
            if (lang) {
                if (!_this.dictionary[lang.languageKey.toString()]) {
                    _this.dictionary[lang.languageKey.toString()] = {};
                }
                var currDict_1 = _this.dictionary[lang.languageKey.toString()];
                if (currDict_1.hasOwnProperty(key)) {
                    return of(currDict_1[key]);
                }
                else {
                    if (!_this.getFromServerTimer) {
                        _this.getFromServerTimer = timer(5);
                        _this.keysFromServer = [key];
                        _this.waitingForServerTranslationsObs = _this.getFromServerTimer.pipe(flatMap(function () {
                            var usedLang = _this.intlServicePP.usedLanguage.languageKey;
                            if (!_this.dictionary[usedLang.toString()]) {
                                _this.dictionary[usedLang.toString()] = {};
                            }
                            var usedDict = _this.dictionary[usedLang.toString()];
                            return _this.translateProxy.getLookupDataTranslation(usedLang, _this.keysFromServer).pipe(map(function (res) {
                                _this.keysFromServer.forEach(function (currKey, index) {
                                    usedDict[currKey] = res[index];
                                });
                                _this.keysFromServer = [];
                                return res;
                            }));
                        }));
                        _this.waitingForServerTranslationsObs = _this.waitingForServerTranslationsObs.pipe(share());
                    }
                    else {
                        if (!_this.keysFromServer.includes(key)) {
                            _this.keysFromServer.push(key);
                        }
                    }
                    return _this.waitingForServerTranslationsObs.pipe(map(function () { return currDict_1[key]; }));
                }
            }
        }));
    };
    TranslateService.prototype.translateOrgStructureDescription = function (keys) {
        var _this = this;
        var ofKeys = [];
        keys.forEach(function (k) {
            ofKeys.push(_this.transformLookup(ORG_STRUCTURE_DESCRIPTION_PREFIX + k + LOOKUP_DATA_SUFFIX));
        });
        return zip.apply(void 0, tslib_1.__spread(ofKeys)).pipe(map(function (o) {
            var res = [];
            o.forEach(function (currO, i) {
                if (!res.find(function (r) { return r.key === keys[i]; })) {
                    res.push({ key: keys[i], translation: currO });
                }
            });
            return res;
        }));
    };
    TranslateService.prototype.stringFormatter = function (format, values) {
        return format.replace(/{{a(\d+)}}/g, function (match, i) {
            return values[i] !== null && values[i] !== undefined ? values[i] : match;
        });
    };
    // Checks if key for translate already contains registered translate suffix
    TranslateService.prototype.containsRegisteredTranslateSuffix = function (key) {
        var suffixes = [ACTION_SUFFIX, LABEL_SUFFIX, LOGIN_SUFFIX, MESSAGE_SUFFIX, TITLE_SUFFIX,
            ORG_STRUCTURE_DESCRIPTION_PREFIX, ORG_STRUCTURE_LOCATION_DESCRIPTION_PREFIX, PROCEDURE_CODE_DESCRIPTION_PREFIX,
            SPS_CODE_DESCRIPTION_PREFIX, LOOKUP_DATA_SUFFIX];
        return !suffixes.every(function (suffix) { return key.indexOf(suffix) < 0; });
    };
    TranslateService.prototype.getTranslationsFromServer = function (lang) {
        return this.translateProxy.getTranslation(lang);
    };
    TranslateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function TranslateService_Factory() { return new TranslateService(i0.ɵɵinject(i1.TranslateProxy), i0.ɵɵinject(i2.IntlServicePP)); }, token: TranslateService, providedIn: "root" });
    return TranslateService;
}());
export { TranslateService };
